"use client";

import { IconButton } from "@/components/ui/atoms/icon-button";
import {
  PauseIcon,
  PlayIcon,
  StopIcon,
} from "@/components/ui/atoms/icons";

type TransportControlsProps = {
  isPlaying: boolean;
  onPlayPause: () => void;
  onStop: () => void;
};

export function TransportControls({
  isPlaying,
  onPlayPause,
  onStop,
}: TransportControlsProps) {
  return (
    <div className="flex items-center gap-2">
      <IconButton
        onClick={onPlayPause}
        active={isPlaying}
        variant={isPlaying ? "accent" : "default"}
        title={isPlaying ? "Pause" : "Play"}
      >
        {isPlaying ? <PauseIcon size={16} /> : <PlayIcon size={16} />}
      </IconButton>

      <IconButton onClick={onStop} title="Stop">
        <StopIcon size={16} />
      </IconButton>
    </div>
  );
}
